const GridBackdrop = () => (
  <div
    className="absolute inset-0 pointer-events-none opacity-[0.07] dark:opacity-[0.12]"
    aria-hidden="true"
    style={{
      backgroundImage: `linear-gradient(to right, hsl(var(--foreground)) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--foreground)) 1px, transparent 1px)`,
      backgroundSize: "48px 48px",
      WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)",
      maskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)",
    }}
  />
);

export default GridBackdrop;